import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import Loading from "./loading.js";
import MultiSelect from "./multiSelect.js";
import { secretKey } from "./data";
import LeadDetail from "./leadDetail";
import ShowNote from "./showNote";
import AddContact from "./addContact";
import {
  faEdit,
  faEye,
  faEyeSlash,
  faFile,
  faCheck,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { downloadExcel } from "react-export-table-to-excel";
import AddCon from "./addCon";
import Conf from "./conf";
import Statistics from "./statistics";

const MySwal = withReactContent(Swal2);

const Replace = (props) => {
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [user, setUser] = useState("");
  const [userFrom, setUserFrom] = useState("");
  const [statuses, setStatuses] = useState([]);
  const [sources, setSources] = useState([]);
  const [selectedOptionsStatus, setSelectedOptionsStatus] = useState([]);
  const [isHoveringStatus, setIsHoveringStatus] = useState(false);
  const [chooseStatus, setChooseStatus] = useState("");
  const [selectedOptionsSource, setSelectedOptionsSource] = useState([]);
  const [isHoveringSource, setIsHoveringSource] = useState(false);
  const [chooseSource, setChooseSource] = useState("");
  const [count, setCount] = useState(0);

  const handleChangeChooseStatus = (e) => {
    console.log(e);
    setChooseStatus(e);
  };

  const handleChangeChooseSource = (e) => {
    console.log(e);
    setChooseSource(e);
  };

  const closeAllHovering = (e) => {
    if (e.target.id !== "status" && e.target.id !== "source") {
      setIsHoveringStatus(false);
      setIsHoveringSource(false);
    }
  };

  const fetchUsersFull = async () => {
    var body = {};

    await fetch("https://apisellcrm.ftpeople.pl/getUsersListAll", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data.filter((el) => +el.split === 1));
        setUser(data.filter((el) => +el.split === 1)[0].id);
        fetchStatuses();
      })
      .catch((error) => {});
  };

  const fetchStatuses = async () => {
    var body = {};

    await fetch("https://apisellcrm.ftpeople.pl/getStatuses", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setStatuses(data);
        fetchSources();
      })
      .catch((error) => {});
  };

  const fetchSources = async () => {
    var body = {};

    await fetch("https://apisellcrm.ftpeople.pl/getLeadSources", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSources(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    fetchUsersFull();
  };

  useEffect(() => {
    getData();
  }, []);

  const getStatusOptions = (e) => {
    var arr = [];

    statuses.map((el) => {
      var opt = { label: el.name, value: el.name };
      arr.push(opt);
    });

    return arr;
  };

  const getSourceOptions = (e) => {
    var arr = [];

    sources.map((el) => {
      var opt = { label: el.name, value: el.name };
      arr.push(opt);
    });

    return arr;
  };

  const changeLeads = async () => {
    if (chooseSource.length === 0 || chooseStatus.length === 0) {
      MySwal.fire({
        icon: "error",
        title: "Wypełnij",
        text: "wymagane pola formularza",
      });
    } else {
      var body = {
        statuses: chooseStatus,
        sources: chooseSource,
        user: user,
        userFrom: userFrom,
        count: count,
      };

      await fetch("https://apisellcrm.ftpeople.pl/replaceSeller", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.text())
        .then((data) => {
          MySwal.fire({
            icon: "success",
            title: "Przepisano",
            text: "leady",
          });
          setChooseSource([]);
          setChooseStatus([]);
          setSelectedOptionsSource([]);
          setSelectedOptionsStatus([]);
          setUser(users[0].id);
          setCount(0);
        });
    }
  };

  return (
    <div onClick={closeAllHovering}>
      {" "}
      {loading ? (
        <Loading />
      ) : (
        <>
          <div style={{ textAlign: "left", margin: "1%  " }}>
            <p style={{ fontSize: "2vw", fontWeight: "900", margin: "0" }}>
              PRZEPISZ LEADY
            </p>
          </div>
          <div>
            <div style={{ width: "23%", textAlign: "left" }}>
              <p
                style={{
                  margin: "0",
                  marginBottom: "10px",
                  fontWeight: "600",
                  fontSize: "1vw",
                  paddingLeft: "2px",
                }}
              >
                statusy
              </p>
              <MultiSelect
                options={getStatusOptions()}
                value={chooseStatus}
                onChange={handleChangeChooseStatus}
                selectedOptions={selectedOptionsStatus}
                setSelectedOptions={setSelectedOptionsStatus}
                isHovering={isHoveringStatus}
                setIsHovering={setIsHoveringStatus}
                id={"status"}
                closeAllHovering={closeAllHovering}
              />
            </div>
            <div style={{ width: "23%", textAlign: "left", marginTop: "1vh" }}>
              <p
                style={{
                  margin: "0",
                  marginBottom: "10px",
                  fontWeight: "600",
                  fontSize: "1vw",
                  paddingLeft: "2px",
                }}
              >
                źródła
              </p>
              <MultiSelect
                options={getSourceOptions()}
                value={chooseSource}
                onChange={handleChangeChooseSource}
                selectedOptions={selectedOptionsSource}
                setSelectedOptions={setSelectedOptionsSource}
                isHovering={isHoveringSource}
                setIsHovering={setIsHoveringSource}
                id={"status"}
                closeAllHovering={closeAllHovering}
              />
            </div>
            <div style={{ width: "40%", textAlign: "left", marginTop: "1vh" }}>
              <p
                style={{
                  margin: "0",
                  marginBottom: "10px",
                  fontWeight: "600",
                  fontSize: "1vw",
                  paddingLeft: "2px",
                }}
              >
                od kogo?
              </p>
              <select
                style={{
                  height: "4vh",
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid black",
                  fontSize: "0.6vw",
                  borderRadius: "5px",
                  padding: "0px 10px",
                  width: "100%",
                  boxSizing: "border-box",
                }}
                value={userFrom}
                onChange={(e) => {
                  setUserFrom(e.target.value);
                }}
              >
                {users.map((el) => (
                  <option key={el.id} value={el.id}>
                    {el.name}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ width: "40%", textAlign: "left", marginTop: "1vh" }}>
              <p
                style={{
                  margin: "0",
                  marginBottom: "10px",
                  fontWeight: "600",
                  fontSize: "1vw",
                  paddingLeft: "2px",
                }}
              >
                na kogo?
              </p>
              <select
                style={{
                  height: "4vh",
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid black",
                  fontSize: "0.6vw",
                  borderRadius: "5px",
                  padding: "0px 10px",
                  width: "100%",
                  boxSizing: "border-box",
                }}
                value={user}
                onChange={(e) => {
                  setUser(e.target.value);
                }}
              >
                {users.map((el) => (
                  <option key={el.id} value={el.id}>
                    {el.name}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ width: "40%", textAlign: "left", marginTop: "1vh" }}>
              <p
                style={{
                  margin: "0",
                  marginBottom: "10px",
                  fontWeight: "600",
                  fontSize: "1vw",
                  paddingLeft: "2px",
                }}
              >
                ilość leadów (pozostaw 0, jeżeli wszystkie)
              </p>
              <input
                type="number"
                style={{
                  height: "4vh",
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid black",
                  fontSize: "0.6vw",
                  borderRadius: "5px",
                  padding: "0px 10px",
                  width: "100%",
                  boxSizing: "border-box",
                }}
                value={count}
                onChange={(e) => {
                  setCount(e.target.value);
                }}
              />
            </div>
            <div style={{ textAlign: "left", marginTop: "5vh" }}>
              <button
                className="loginButtonLogin"
                value="yes"
                style={{
                  margin: "0",
                  backgroundColor: "green",
                  borderColor: "green",
                  color: "white",
                  width: "20vw",
                  height: "3vh",
                }}
                onClick={() => {
                  changeLeads();
                }}
              >
                PRZEPISZ
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Replace;
